import React from 'react';

import { Button, Divider, Icon, useTranslation } from '@testsigma/atoms';
import tickIcon from '@images/tick.svg';

import { DocumentURL } from '@utils/common';
import { useConnectionSuccessful } from '../../hooks';

export const MetadataConnectionUpdateSuccessScreen: React.FC = () => {
  const { t } = useTranslation();
  const { getEnvironmentInfo, handleDone, handleGoBack } =
    useConnectionSuccessful();

  return (
    <>
      <div className='flex items-center justify-between h-[60px]'>
        <div className='flex items-center'>
          <div className='ml-8 items-center my-4 mr-1 font-medium text-[18px] text-secondary-unique-600'>
            {t('metadata.connection.label')}
          </div>
          <DocumentURL path='docs/salesforce-testing/introduction/'>
            <Icon
              name='help'
              toolTip={t('connection.help.tooltip')}
              className='flex items-center text-secondary-400 hover:text-secondary-500'
            />
          </DocumentURL>
        </div>
      </div>

      <Divider type='solid' />

      <div className='flex flex-col h-full pt-6 pb-8 px-8 items-center'>
        <div className=' mt-4'>
          <img
            src={tickIcon}
            className='empty-illustration'
            alt='Tick Illustration'
          />
        </div>
        <div className='flex flex-col my-[48px]'>
          <span
            className='text-[15px] font-semibold leading-6 text-secondary-text text-center'
            dangerouslySetInnerHTML={{
              __html: t('salesforce-env.info', {
                environmentInfo: getEnvironmentInfo(),
              }),
            }}
          />
          <span className='leading-6 text-secondary-text text-center text-sm mt-6'>
            {t('salesforce-env.description')}
          </span>
        </div>

        <Button type='primary' onClick={handleDone}>
          {t('common.done')}
        </Button>

        <Button type='secondary' className='mt-[42px]' onClick={handleGoBack}>
          {t('common.go-back.label')}
        </Button>
      </div>
    </>
  );
};
